




















































import { Component, Vue, Prop } from 'vue-property-decorator'
import { Utils } from '@/pitprojekt/utils';

@Component({})
export default class DetailedStatsTable extends Vue {
@Prop(Array) data!: object
@Prop(Array) headers!: object
@Prop(Boolean) dense!: boolean
@Prop(Boolean) loading!: boolean
@Prop(Boolean) simplePagination!: boolean
@Prop(Boolean) highlightWeekends!: boolean
itemsPerPageOptionsSimple: object = {'items-per-page-options': [20]};
itemsPerPageOptions: object = {'items-per-page-options': [5, 10, 15, 20, 50, 100], 'items-per-page-text': 'Wyników na stronę'};

  get simpleRouteName(): string {
    return Utils.getSimpleRouteName(this.$route.name);
  }

  get getItemsPerPageOptions():object {
    return (this.simplePagination) ? this.itemsPerPageOptionsSimple : this.itemsPerPageOptions;
  }

  getOperatingSystemIconUrl(platform: string): string {
    return Utils.getOperatingSystemIconUrl(platform);
  }

  getStatDeklaracjeModulIconName(module: string): string {
    return Utils.getStatDeklaracjeModulIconName(module);
  }

  clickedIP(ip: string) {
    this.$emit('clickedIP', ip);
  }

}
